import {Injectable} from '@angular/core'
import {Platform} from 'ionic-angular';
import {Globales} from './funciones';
import {Calendar} from '@ionic-native/calendar';

@Injectable()

export class Calendario {


  permiso_lectura: any = false;
  permiso_escritura: any = false;
  event_obtions: any;

  constructor(
    public platform: Platform,
    public gl: Globales,
    public calendar: Calendar
  ) {

    if (this.platform.is('cordova')) {

      this.getPermisoEscritura();
      this.getPermisoLectura();
      this.getEventOptions();
    }
  }


  /**
   * Guarda una tarea en el calendario nativo si esta no existe ya
   *
   */
  setTarea(item, notificar = true) {

    let date_milisecosn = parseInt(item.fecha);
    let startDate = new Date(date_milisecosn);
    let endDate = new Date(date_milisecosn + 3600000);


    if ('calendarName' in this.event_obtions) {

      this.event_obtions.calendarName = 'yurest';
    }

    this.calendar.findEvent(item.titulo, item.ubicacion ? item.ubicacion : '', item.descripcion ? item.descripcion : '', startDate, endDate).then((data) => {

      console.log(data);

      if (!data || data.length == 0) {

        this.calendar.createEventWithOptions(item.titulo, item.ubicacion ? item.ubicacion : '', item.descripcion ? item.descripcion : '', startDate, endDate, this.event_obtions)
          .then(() => {
            if (notificar) {
              this.gl.showToast('La tarea se ha exportado al calendario nativo de tu dispositivo correctamente', 3000);
            }
          })
          .catch((err) => {

            if (notificar) {
              this.gl.showToast('Ha ocurrido un error exportando la tarea', 3000);
            }
            console.log(err);
            throw err;
          });

      } else {

        if (notificar) {
          this.gl.showToast('La tarea ya existe en tu calendario nativo.', 3000);
        }
      }
    });

  }


  /**
   * Crea un calendario con un nombre y color (only ios)
   *
   */
  createCalendar(name, color) {

    this.calendar.createCalendar({calendarName: name, calendarColor: color})
  }


  /**
   * Recupera las opciones de los eventos
   *
   */
  getEventOptions() {

    this.event_obtions = this.calendar.getCalendarOptions();
  }


  /**
   * Realiza las llamadas para solicitar el permiso de escritura si no lo tiene
   *
   */
  getPermisoEscritura() {
    this.calendar.hasWritePermission().then((has) => {

      this.permiso_escritura = has;

      if (!has) {

        this.calendar.requestWritePermission().then(() => {

          this.permiso_escritura = true;
          this.createCalendar('yurest', '#ff5252');

        }).catch((err) => {

          this.permiso_escritura = false;
        });

      } else {

        this.createCalendar('yurest', '#ff5252');
      }
    });
  }


  /**
   * Realiza las llamadas para solicitar el permiso de lectura si no lo tiene
   *
   */
  getPermisoLectura() {

    this.calendar.hasReadPermission().then((has) => {

      this.permiso_lectura = has;

      if (!has) {


        this.calendar.requestReadPermission().then(() => {

          this.permiso_lectura = true;
          this.getEventOptions();

        }).catch((err) => {

          this.permiso_lectura = false;
        });

      } else {

        this.getEventOptions();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/classes/calendario.ts